import {PostTypes} from 'features/postGenerator/constants';
import {chunk} from 'lodash';
import {PubBeer} from 'typescript/models/PubBeer';

interface IRenderStandardBeersArgs {
  pubBeerList: PubBeer[];
  postType: keyof typeof PostTypes;
  isPriceChecked: boolean;
}

const renderStandardBeers = ({pubBeerList, postType, isPriceChecked}: IRenderStandardBeersArgs) => {
  let pages: PubBeer[][] = [];

  switch (postType) {
    case 'instagramStory':
      {
        let firstPage;
        let otherPages;

        if (!isPriceChecked) {
          firstPage = pubBeerList.splice(0, 5);
          otherPages = chunk(pubBeerList, 8);
        } else {
          firstPage = pubBeerList.splice(0, 6);
          otherPages = chunk(pubBeerList, 10);
        }

        pages = [firstPage, ...otherPages];
      }
      break;
    case 'pubTV':
      {
        const firstPage = pubBeerList.splice(0, 16);
        const otherPages = chunk(pubBeerList, 12);

        pages = [firstPage, ...otherPages];
      }
      break;
    case 'facebookTimeline':
      {
        const firstPage = pubBeerList.splice(0, 8);
        const otherPages = chunk(pubBeerList, 12);
        pages = [firstPage, ...otherPages];
      }
      break;
    case 'instagramPortrait':
      {
        const firstPage = pubBeerList.splice(0, 4);
        let otherPages = chunk(pubBeerList, 6);

        if (!isPriceChecked) otherPages = chunk(pubBeerList, 5);

        pages = [firstPage, ...otherPages];
      }
      break;

    case 'instagramSquare':
      {
        const firstPage = pubBeerList.splice(0, 2);
        const otherPages = chunk(pubBeerList, isPriceChecked ? 6 : 5);
        pages = [firstPage, ...otherPages];
      }
      break;
    default:
      {
        const firstPage = pubBeerList.splice(0, 2);
        const otherPages = chunk(pubBeerList, 6);
        pages = [firstPage, ...otherPages];
      }
      break;
  }

  return pages;
};

const renderStandard2Beers = (pubBeerList: PubBeer[], postType: keyof typeof PostTypes) => {
  let pages: PubBeer[][] = [];

  switch (postType) {
    case 'instagramStory':
      {
        const firstPage = pubBeerList.splice(0, 10);
        const otherPages = chunk(pubBeerList, 10);
        pages = [firstPage, ...otherPages];
      }
      break;
    case 'pubTV':
      {
        const firstPage = pubBeerList.splice(0, 20);
        const otherPages = chunk(pubBeerList, 24);
        pages = [firstPage, ...otherPages];
      }
      break;
    case 'facebookTimeline':
      {
        const firstPage = pubBeerList.splice(0, 6);
        const otherPages = chunk(pubBeerList, 9);
        pages = [firstPage, ...otherPages];
      }
      break;

    case 'instagramPortrait':
      {
        const firstPage = pubBeerList.splice(0, 2);
        const otherPages = chunk(pubBeerList, 6);
        pages = [firstPage, ...otherPages];
      }
      break;

    default:
      {
        const firstPage = pubBeerList.splice(0, 2);
        const otherPages = chunk(pubBeerList, 4);
        pages = [firstPage, ...otherPages];
      }
      break;
  }

  return pages;
};

export {renderStandardBeers, renderStandard2Beers};
